




















import { Vue, Component, Prop } from "vue-property-decorator";

// Enums/Data
import { ProvisionFieldTypes } from "@/data/enums/provisioning";

// Types
import { IBlueprintField } from "@/models/provisioning";

@Component({
  components: {
    "provision-field": () =>
      import(
        "@/components/app/admin/catalogue/products/provisioning/provisionField.vue"
      )
  }
})
export default class AttributeMultiValue extends Vue {
  @Prop({ required: true })
  public value!: any;

  @Prop({ required: true })
  public attribute!: IBlueprintField;

  @Prop({ default: false })
  public isDisabled!: boolean;

  @Prop({ required: true })
  public fieldValues!: IBlueprintField;

  public provisionFieldTypes = ProvisionFieldTypes;

  public get attributeValues() {
    return this.$_.map(this.value, value => {
      const emptyRow = this.emptyRow();
      emptyRow[this.attributeName] = value;
      return emptyRow;
    });
  }

  public set attributeValues(attributeValues) {
    this.$emit(
      "input",
      this.$_.map(
        this.$_.filter(
          attributeValues,
          attributeValue => attributeValue[this.attributeName] !== null
        ),
        value => value[this.attributeName]
      )
    );
  }

  public get attributeName() {
    return this.attribute.name;
  }

  public emptyRow() {
    const emptyRow = {};
    emptyRow[this.attributeName] = null;

    return emptyRow;
  }
}
